<template>
  <iModal
    :visible="applyToNetworkModalOpen"
    title="Apply to Join Network"
    :max-width="600"
    @close="closeModal"
  >
    <template #body>
      <iColumn gap="large">
        <iColumn gap="none">
          <iAutoComplete
            label="Which Publication?"
            :items="formattedPublications"
            :model-value="publication"
            width="fill"
            item-value-key="value"
            item-label-key="label"
            placeholder="Search for a publication"
            @update:model-value="handleChange"
          />
          <iText v-if="validationErrors.publication" variant="error">
            {{ validationErrors.publication }}
          </iText>
        </iColumn>
        <iColumn gap="none">
          <iTextArea
            v-model="message"
            label="Application Message"
            placeholder="Enter application message..."
            :rows="5"
            width="fill"
          />
          <iText v-if="validationErrors.message" variant="error">
            {{ validationErrors.message }}
          </iText>
        </iColumn>
        <iText v-if="error" variant="error">
          {{ error }}
        </iText>
      </iColumn>
    </template>
    <template #footer>
      <iRow align="right" gap="standard">
        <iColumn width="hug">
          <iButton variant="secondary" @click="closeModal">
            Cancel
          </iButton>
        </iColumn>
        <iColumn width="hug">
          <iButton
            variant="primary"
            loading-spinner-position="inside"
            :is-loading="isLoadingApplyToNetwork"
            @click="submit"
          >
            Submit Application
          </iButton>
        </iColumn>
      </iRow>
    </template>
  </iModal>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useNetworkStore } from "@/stores/network-store";
import { useUserStore } from "@/stores/user-store";
import { useGeneralStore } from "%/stores/general-store";
import { usePublicationEntityStore } from "SmartFeed/stores/entity/publication-entity-store";
import { useMyPublicationFeedStore } from "SmartFeed/stores/feed/my-publication-feed-store";

export default {
  name: "ApplyToNetworkModal",
  props: {
    networkId: { type: Number, required: true },
    publicationId: { type: Number, required: true },
  },
  data() {
    return {
      message: "",
      publication: "",
      validationErrors: {
        message: "",
        publication: "",
      },
    };
  },
  computed: {
    ...mapState(useNetworkStore, [
      "applyToNetworkModalOpen",
      "isLoadingApplyToNetwork",
      "error",
    ]),
    ...mapState(useUserStore, ["userData"]),
    ...mapState(useGeneralStore, ["orgId", "userId"]),
    publications() {
      return Object.values(usePublicationEntityStore().entities);
    },
    formattedPublications() {
      return this.publications.map(item => ({
        value: item.publicationId,
        label: item.name,
      }));
    },
  },
  mounted() {
    useMyPublicationFeedStore().getSmartFeed();
  },
  methods: {
    ...mapActions(useNetworkStore, [
      "applyToNetwork",
      "closeApplyToNetworkModal",
    ]),
    closeModal() {
      this.closeApplyToNetworkModal();
      this.message = "";
      this.publication = "";
      this.validationErrors.message = "";
      this.validationErrors.publication = "";
    },
    handleChange(value) {
      this.publication = value;
    },
    submit() {
      this.validationErrors.message = "";
      this.validationErrors.publication = "";

      if (!this.message) {
        this.validationErrors.message = "Application message is required";
      }

      if (!this.publication) {
        this.validationErrors.publication = "Please select a publication";
      }

      if (this.validationErrors.message || this.validationErrors.publication) {
        return;
      }

      this.applyToNetwork(
        this.networkId,
        this.publication,
        this.orgId,
        this.userId,
        this.message,
        this.closeModal,
      );
    },
  },
};
</script>

<style scoped>
</style>
